import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SubscriptionIcon from 'rebook/apps/base/components/icons/SubscriptionIcon';
import PaymentsAvailableContentCounters from 'rebook/apps/payments/components/PaymentsAvailableContentCounters';

import styles from './style.scss';


const subscriptionIcons = {
  standard: <SubscriptionIcon type="standard" extraClassName={styles.iconImage} />,
  pro: <SubscriptionIcon type="premium" extraClassName={styles.iconImage} />,
};

const PaymentsHeader = ({ children, title, isGift, subscriptionType, subtitle, booksPerSubscriptionCounter }) => (
  <div className={styles.paymentsSubscriptionHeader}>
    <div
      className={classNames(styles.title, 'title-1')}
      dangerouslySetInnerHTML={{ __html: title }} />
    {!!subtitle && (<p className={styles.subtitle}>{subtitle}</p>)}
    <PaymentsAvailableContentCounters
      isPro={subscriptionType==='pro'}
      booksPerSubscriptionCounter={booksPerSubscriptionCounter}
      isSubscriptionTypeSelected />
    <div className={classNames(styles.icon, isGift && 'hasGift', styles[`icon${subscriptionType}`])}>
      {subscriptionIcons[subscriptionType]}
    </div>
    <div className={styles.userSubscription}>
      {children}
    </div>
  </div>
);

PaymentsHeader.propTypes = {
  title: PropTypes.string.isRequired,
  isGift: PropTypes.bool,
  subscriptionType: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  booksPerSubscriptionCounter: PropTypes.object,
};

export default PaymentsHeader;
